import type { ISecrEnergySourceLine } from '../../../../shared/services/generated-report/generated-report.model';
import { SECR_EM_DASH, formatSecrReportNumber } from './secr-number-format';
import { isMetricApplicableForSourceKey, isTotalMetricApplicable, type SecrSourceMetricField } from './secr-source-applicability';

export function formatSecrSourceDataCell(
  sourceKey: string,
  field: SecrSourceMetricField,
  raw: number | null | undefined
): string {
  if (!isMetricApplicableForSourceKey(sourceKey, field)) {
    return SECR_EM_DASH;
  }
  if (raw === null || raw === undefined || Number.isNaN(Number(raw))) {
    return SECR_EM_DASH;
  }
  return formatSecrReportNumber(Number(raw));
}

export function formatSecrSourceTotalCell(
  dataLines: ISecrEnergySourceLine[],
  field: SecrSourceMetricField,
  raw: number | null | undefined
): string {
  if (!isTotalMetricApplicable(dataLines, field)) {
    return SECR_EM_DASH;
  }
  if (raw === null || raw === undefined || Number.isNaN(Number(raw))) {
    return SECR_EM_DASH;
  }
  return formatSecrReportNumber(Number(raw));
}
